'use client';

import * as Sentry from '@sentry/nextjs';
import { Suspense, useEffect } from 'react';

import toast from '@edgevanta/ui/lib/toast';

import GlobalError from '@/components/global-error';

export default function ErrorPage({
  error,
}: {
  error: Error & {
    errorId?: string;
  };
}) {
  useEffect(() => {
    (async () => {
      try {
        await Sentry.captureException(error);
      } catch (err) {
        toast.error(
          `Failed to send the error to Sentry: ${(err as Error).message}`,
        );
      }
    })();
  }, [error]);

  return (
    <Suspense fallback={null}>
      <GlobalError errorId={error.errorId} />
    </Suspense>
  );
}
